import _regeneratorRuntime from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { calcEasing, clamp, getDistances } from "../../../Utils/NumberUtils";
import { Circle } from "../../../Core/Utils/Circle";
import { Constants } from "../../../Core/Utils/Constants";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
import { Vector } from "../../../Core/Utils/Vector";
import { isInArray } from "../../../Utils/Utils";
export var Attractor = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Attractor, _ExternalInteractorBa);

  var _super = _createSuper(Attractor);

  function Attractor(container) {
    var _this;

    _classCallCheck(this, Attractor);

    _this = _super.call(this, container);

    if (!container.attract) {
      container.attract = {
        particles: []
      };
    }

    _this.handleClickMode = function (mode) {
      var options = _this.container.actualOptions;

      if (mode !== "attract") {
        return;
      }

      if (!container.attract) {
        container.attract = {
          particles: []
        };
      }

      container.attract.clicking = true;
      container.attract.count = 0;

      var _iterator = _createForOfIteratorHelper(container.attract.particles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;
          particle.velocity.setTo(particle.initialVelocity);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      container.attract.particles = [];
      container.attract.finish = false;
      setTimeout(function () {
        if (!container.destroyed) {
          if (!container.attract) {
            container.attract = {
              particles: []
            };
          }

          container.attract.clicking = false;
        }
      }, options.interactivity.modes.attract.duration * 1000);
    };

    return _this;
  }

  _createClass(Attractor, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events;

      if ((!mouse.position || !events.onHover.enable) && (!mouse.clickPosition || !events.onClick.enable)) {
        return false;
      }

      var hoverMode = events.onHover.mode,
          clickMode = events.onClick.mode;
      return isInArray("attract", hoverMode) || isInArray("attract", clickMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container, options, mouseMoveStatus, events, hoverEnabled, hoverMode, clickEnabled, clickMode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, options = container.actualOptions, mouseMoveStatus = container.interactivity.status === Constants.mouseMoveEvent, events = options.interactivity.events, hoverEnabled = events.onHover.enable, hoverMode = events.onHover.mode, clickEnabled = events.onClick.enable, clickMode = events.onClick.mode;

                if (mouseMoveStatus && hoverEnabled && isInArray("attract", hoverMode)) {
                  this.hoverAttract();
                } else if (clickEnabled && isInArray("attract", clickMode)) {
                  this.clickAttract();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "hoverAttract",
    value: function hoverAttract() {
      var container = this.container;
      var mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var attractRadius = container.retina.attractModeDistance;
      this.processAttract(mousePos, attractRadius, new Circle(mousePos.x, mousePos.y, attractRadius));
    }
  }, {
    key: "processAttract",
    value: function processAttract(position, attractRadius, area) {
      var container = this.container;
      var attractOptions = container.actualOptions.interactivity.modes.attract;
      var query = container.particles.quadTree.query(area);

      var _iterator2 = _createForOfIteratorHelper(query),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var particle = _step2.value;

          var _getDistances = getDistances(particle.position, position),
              dx = _getDistances.dx,
              dy = _getDistances.dy,
              distance = _getDistances.distance;

          var velocity = attractOptions.speed * attractOptions.factor;
          var attractFactor = clamp(calcEasing(1 - distance / attractRadius, attractOptions.easing) * velocity, 0, attractOptions.maxSpeed);
          var normVec = Vector.create(distance === 0 ? velocity : dx / distance * attractFactor, distance === 0 ? velocity : dy / distance * attractFactor);
          particle.position.subFrom(normVec);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "clickAttract",
    value: function clickAttract() {
      var container = this.container;

      if (!container.attract) {
        container.attract = {
          particles: []
        };
      }

      if (!container.attract.finish) {
        if (!container.attract.count) {
          container.attract.count = 0;
        }

        container.attract.count++;

        if (container.attract.count === container.particles.count) {
          container.attract.finish = true;
        }
      }

      if (container.attract.clicking) {
        var mousePos = container.interactivity.mouse.clickPosition;

        if (!mousePos) {
          return;
        }

        var attractRadius = container.retina.attractModeDistance;
        this.processAttract(mousePos, attractRadius, new Circle(mousePos.x, mousePos.y, attractRadius));
      } else if (container.attract.clicking === false) {
        container.attract.particles = [];
      }

      return;
    }
  }]);

  return Attractor;
}(ExternalInteractorBase);